module.exports = __webpack_public_path__ + "8a5e569c00ea57396b773bd6d5c324f7.png";